export default function PHP_ftp_nb_put() {
  return (
    <div>
      <h1>PHP_ftp_nb_put</h1>
    </div>
  );
}
